export default {
    //超级管理员身份——头导航
    routes: [{
        path: '/importData',
        name: '数据导入'
    },
    {
        path: '/kgList/Master?user=baibai',
        name: '幼儿园管理',
    },
    // {
    //     path: '/wechatCode',
    //     name: '公众号',
    // },
    ],
    //机构管理子菜单
    agencyProxyRoutes: [
        {
            path: '/allianceList',
            name: '加盟商管理',
        },
        {
            path: '/agencyList/Master?user=baibai',
            name: '机构管理'
        },
        {
            path: '/proxyList/Master?user=baibai',
            name: '代理管理'
        },
    ],
    //课程管理子菜单
    courseManagementRoutes: [
        {
            path: '/course',
            name: '课程',
        },
        {
            path: '/training',
            name: '师训',
        },
        {
            path: '/activity',
            name: '活动',
        },
        {
            path: '/kangarooCoursePackage',
            name: '袋鼠圈课程'
        }
    ],
    //加盟商身份——头导航
    allianceRoutes: [{
        path: '/allianceMain/allianceMaster/allianceHome',
        name: '主页',
    }, {
        path: '/allianceMain/allianceProject/projectSpeed',
        name: '项目进度'
    }, {
        path: '/allianceMain/allianceMaster/teacherPlatform',
        name: '师资平台'
    }, {
        path: '/allianceMain/allianceMaster/kdgConnect',
        name: '园所沟通'
    },
    // {
    //     path: '/wechatCode',
    //     name: '公众号',
    // },
    ],
    //机构身份——头导航
    agencyRoutes: [{
        path: '/importData',
        name: '数据导入'
    },
    {
        path: '/agencyHome',
        name: '机构主页'
    }, {
        path: '/kgList/Agency',
        name: '园所管理'
    },
    // {
    //     path: '/wechatCode',
    //     name: '公众号',
    // },
    // {
    //     path: '/testersManagement',
    //     name: '测试员管理'
    // },

    ],
    //代理身份——头导航
    proxyRoutes: [
        {
            path: '/proxyHome',
            name: '代理主页'
        }, {
            path: '/kgList/Proxy',
            name: '园所管理'
        }, 
        // {
        //     path: '/testersManagement',
        //     name: '测试员管理'
        // }, 
        {
            path: '/importData',
            name: '数据导入'
        },
        // {
        //     path: '/wechatCode',
        //     name: '公众号',
        // },

    ],
    //园长身份——头导航
    kgRoutes: [
        {
            path: '/kindergartenMain/kindergartenMaster/kgHomeNew',
            name: '园所主页'
        }, {
            path: '/kindergartenMain/kdg/exercisePlan',
            name: '体格锻炼计划'
        }, {
            path: '/kindergartenMain/kdg/childList',
            name: '幼儿园管理'
        }, {
            path: '/kindergartenMain/kdg/teacherManagement',
            name: '教师管理'
        }, {
            path: '/kindergartenMain/kdg/screeningChildren',
            name: '幼儿筛选'
        }
    ],
    //园长身份——头导航-贝码
    kgRoutesBeiMa: [
        {
            path: '/kindergartenMain/kindergartenMaster/kgHomeNew',
            name: '园所主页'
        }, {
            path: '/kindergartenMain/kdg/childList',
            name: '幼儿园管理'
        }, {
            path: '/kindergartenMain/kdg/teacherManagement',
            name: '教师管理'
        }, {
            path: '/kindergartenMain/kdg/screeningChildren',
            name: '幼儿筛选'
        }
    ],
    //试用期
    kgRoutesProbation: [
        {
            path: '/kindergartenMain/kindergartenMaster/kgHomeNew',
            name: '园所主页'
        }, {
            path: '/kindergartenMain/kdg/childList',
            name: '幼儿园管理'
        }, {
            path: '/kindergartenMain/kdg/screeningChildren',
            name: '幼儿筛选'
        }
    ],

    //园长身份——头导航下拉子菜单
    kindergartenDataBase: [{
        path: '/importData',
        name: '数据导入'
    }, {
        path: '/kindergartenMain/kdg/exportReport',
        name: '数据导出'
    }
    ],
    //加盟商身份——头导航下拉子菜单
    allianceChildRoutes: [{
        path: '/kgList/index',
        name: '幼儿园管理'
    }, {
        path: '/agencyList/index',
        name: '机构管理'
    }, {
        path: '/proxyList/index',
        name: '代理管理'
    }, {
        path: '/allianceMain/allianceMaster/allianceHistoryList',
        name: '历史测试'
    },
    ],
    //芳草园长身份-头导航
    fangCaoKgRoutes: [
        {
            path: '/kindergartenMain/kindergartenMaster/kgHomeNew',
            name: '园所主页'
        }, {
            path: '/kindergartenMain/kdg/childList',
            name: '幼儿园管理'
        }, {
            path: '/kindergartenMain/kdg/teacherManagement',
            name: '教师管理'
        }, {
            path: '/kindergartenMain/kdg/screeningChildren',
            name: '幼儿筛选'
        }
    ],
    //芳草代理身份-头导航
    fangCaoProxyRoutes: [
        {
            path: '/proxyHome',
            name: '代理主页'
        }, {
            path: '/kgList/Proxy',
            name: '园所管理'
        }, {
            path: '/importData',
            name: '数据导入'
        },
        // {
        //     path: '/wechatCode',
        //     name: '公众号',
        // },
    ],
    //芳草加盟商身份-头导航
    fangCaoAllianceRoutes: [
        {
            path: '/allianceMain/allianceMaster/allianceHome',
            name: '主页',
        },
        {
            path: '/kgList/index',
            name: '幼儿园管理'
        }, {
            path: '/proxyList/index',
            name: '代理管理'
        }, {
            path: '/allianceMain/allianceMaster/allianceHistoryList',
            name: '历史测试'
        },
        // {
        //     path: '/wechatCode',
        //     name: '公众号',
        // },
    ],
}


// WEBPACK FOOTER //
// ./src/assets/js/nav-head.js